export const USER_TASK_ENVIRONMENTS = {
  QA: {
    url: "https://usertask-service-grapql-lb4cqj4ohq-uk.a.run.app/graphql",
    app_id: "wscc.qa.automation",
    tenant_id: "ORG-f678c2e3-f094-4521-b3cb-dbcd29a09411",
    user_id: "USER-40822456-2e69-4912-be40-f829617cfe62",
    roles: ["VIEWER", "EDITOR", "MANAGE"],
    scope: ["USER", "APPADMIN", "TENANTADMIN"],
    customFormsUrl:"https://www.wscc.qa.wellsky.io/cfp_gcp/qa/widgets/formsWidgetsNG.js?uuid=abd288f9-63df-4d0a-9bd0-47d6d783ff39",
    appsyncGraphqlEndpoint: "https://cf-api-lb4cqj4ohq-uk.a.run.app/graphql",
    widgetHost:"https://wscc-usertask-service-dev.wscc-dev-dmz.prj.gcp.wellsky.io/index.js"
  },
  DEV: {
    url: "https://usertask-service-grapql-vitumuotya-uk.a.run.app/graphql",
    app_id: "wscc.qa.automation",
    tenant_id: "ORG-f678c2e3-f094-4521-b3cb-dbcd29a09411",
    user_id: "USER-40822456-2e69-4912-be40-f829617cfe62",
    roles: ["VIEWER", "EDITOR", "MANAGE"],
    scope: ["USER", "APPADMIN", "TENANTADMIN"],
    customFormsUrl:"https://www.wscc.dev.wellsky.io/cfp_gcp/dev/widgets/formsWidgetsNG.js?uuid=f31ab7a7-5ab7-431f-9155-b3df27500b92",
    appsyncGraphqlEndpoint: "https://cf-api-vitumuotya-uk.a.run.app/graphql",
    widgetHost:"https://wscc-usertask-service-dev.wscc-dev-dmz.prj.gcp.wellsky.io/index.js"
  },
  LOCAL: {
    url: "https://usertask-service-grapql-vitumuotya-uk.a.run.app/graphql",
    app_id: "wscc.qa.automation",
    tenant_id: "ORG-f678c2e3-f094-4521-b3cb-dbcd29a09411",
    user_id: "USER-40822456-2e69-4912-be40-f829617cfe62",
    roles: ["VIEWER", "EDITOR", "MANAGE"],
    scope: ["USER", "APPADMIN", "TENANTADMIN"],
    customFormsUrl:"https://www.wscc.dev.wellsky.io/cfp_gcp/dev/widgets/formsWidgetsNG.js?uuid=f31ab7a7-5ab7-431f-9155-b3df27500b92",
    appsyncGraphqlEndpoint: "https://cf-api-vitumuotya-uk.a.run.app/graphql",
    widgetHost:"http://localhost:3000/index.js"
  },
};
